













































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IListPalletType from '@/store/models/IListPalletType';
import IBORInboundDetailType from '@/store/models/IBORInboundDetailType';
import IGood from '@/store/models/IGood';
import { BORValidation } from '../../../store/models/BORValidation';
import { BORGood } from '@/store/models/BORGood';
import { BORGoodSave } from '../../../store/models/BORGoodSave';
import { debounce } from 'lodash';

@Component({
    components: {
        Snackbar
    }
})
export default class InboundDetailMapper extends Vue {
    @Prop({ type: Array, required: true })
    BORInboundDetails !: IBORInboundDetailType[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    GoodList !: IGood[];
    @Prop({ type: Array, required: true })
    PalletTypeList !: IListPalletType[];
    @Prop({ type: Array, required: true })
    SuggestedGoods !: BORGood[];

    activeSelectAll : boolean = false;
    selectedBORInboundDetails : IBORInboundDetailType[] = [];
    selectedBORInboundDetailsSelectAll : IBORInboundDetailType[] = [];
    selectedPalletType: IListPalletType = {} as IListPalletType;
    selectedPalletTypeName: string = "";
    selectedPalletAmount: number = 0;
    selectedValidationItem: IBORInboundDetailType = {} as IBORInboundDetailType;
    selectedBestBeforeDate: Date = new Date();
    selectedT1: boolean = false;
    selectedLanguage: string = "";
    dialog: boolean = false;
    dialogT1: boolean = false;
    dialogPalletType: boolean = false;
    dialogPalletAmount: boolean = false;
    dialogValidated: boolean = false;
    dialogBestBeforeDate: boolean = false;
    dialogCreateModifyGood: boolean = false;
    dialogConfirmDelete: boolean = false;
    dialogConfirmDeleteImport: boolean = false;
    dialogLanguage: boolean = false;
    bestBeforeDate: string = new Date().toISOString().substr(0, 10);
    menuBestBeforeDate: boolean = false;
    validations: BORValidation[] = [];
    searchGoods: string = "";
    // goodsPerCase: number = 0;
    goodToAdd: BORGoodSave = {} as BORGoodSave;
    copyBORInboundDetail: IBORInboundDetailType = {} as IBORInboundDetailType;
    newProductsList: IBORInboundDetailType[] = [];
    private initialValidationDone: boolean = false;

    get headersCustom() : any {
        return [
            { text: 'Good Name',
                align: 'start',
                value: 'goodName'
            },
            { text: 'Pallets amount', value: 'palletsAmount' },
            { text: 'Total cases', value: 'totalCases' },
            { text: 'Pallet type', value: 'palletName' },
            { text: 'Cases per pallet', value: 'casesPerPallet' },
            { text: 'Goods per case', value: 'goodsPerCase' },
            { text: 'Best before date', value: 'bestBeforeDate' },
            { text: 'Language', value: 'language' },
            { text: 'Douana Document', value: 'documentation' },
            { text: 'Validated', value: 'validationResult' },
            { text: 'Actions', value: 'actions', sortable: false }
        ];
    }

    validationHeaders = [
        { text: "Validation Code", value: "ErrorCode", align: "start" },
        { text: "Solution", value: "Solution" }
    ];

    suggestionsHeaders = [
        { text: "EAN Code", value: "eanCode", align: "start" },
        { text: "SKU", value: "sku" },
        { text: "Name", value: "name" },
        { text: 'Actions', value: 'actions', sortable: false }
    ];

    get DateOutFormatted() {
        return this.formatDate(this.bestBeforeDate);
    }

    @Watch('BORInboundDetails', { immediate: true, deep: true })
    onBORInboundDetailsChanged(newValue: IBORInboundDetailType[]) {
        if (!this.initialValidationDone && newValue.length > 0) {
            this.validateImportDetails();
            this.initialValidationDone = true;
        }
        if (newValue.length > 0) {
            newValue.forEach(item => {
                this.recalculateCasesPerPallet(item);
            });
        }
    }

    hasMultipleGoodsPerCaseValuesByName(name: string) {
        const values = this.BORInboundDetails
        .filter(x => x.goodName.trim().toLowerCase() === name.trim().toLowerCase())
        .map(x => x.goodsPerCase);

        const unique = Array.from(new Set(values));
        return unique.length > 1; // hay variaciones
    }

    recalculateCasesPerPallet(item: IBORInboundDetailType) {
        if (item.palletsAmount && item.totalCases) {
            const calculatedValue = item.totalCases / item.palletsAmount;
            if (!Number.isInteger(calculatedValue)) {
                item.casesPerPallet = Math.floor(calculatedValue); // Permite mostrar el número decimal
                item.invalidCasesPerPallet = true; // Asegurar reactividad
                this.showMessageWarning(`Total cases cannot be evenly divided by pallets amount for item: ${item.goodName}`);
            } else {
                item.casesPerPallet = calculatedValue;
                item.invalidCasesPerPallet = false;
            }
        }
    }

    useFirstSuggestedGood() {
        if (this.SuggestedGoods.length === 0 || this.newProductsList.length === 0) return;

        const firstSuggested = this.SuggestedGoods[0];
        const currentItem = this.newProductsList[0];

        const index = this.BORInboundDetails.findIndex(g => g.id === currentItem.id);

        if (index !== -1) {
            this.BORInboundDetails[index].goodName = firstSuggested.name;
            this.BORInboundDetails[index].eanCode = firstSuggested.eanCode;
            this.BORInboundDetails[index].sku = firstSuggested.sku;
            this.BORInboundDetails[index].idGood = firstSuggested.id;
            this.BORInboundDetails[index].goodsPerCase = firstSuggested.goodsPerCase || 1;
            this.validateImportDetails();
            this.dialogCreateModifyGood = false;
        }
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    confirmDeleteMultiple() {
        if (this.selectedBORInboundDetails.length > 0) {
            this.$emit('deleteMultiple', this.selectedBORInboundDetails);
            this.dialogConfirmDelete = false;
        }
    }
    
    hasErrorCode(item: IBORInboundDetailType): boolean {
        return item.validations && item.validations.some(validation => validation.ErrorCode === 1001 || validation.ErrorCode === 1002 || validation.ErrorCode === 1003 || validation.ErrorCode === 1009);
    }

    formatDateToString(date: Date) {
        if (!date) return '';
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }
   
    get sortedBORInboundDetails() {
        return this.BORInboundDetails.map(item => {
            // Si goodsPerCase > 0, NO tocarlo nunca
            if (item.goodsPerCase > 0) return item;

            // Si hay líneas con goodsPerCase diferentes: NO AUTOCORREGIR
            if (this.hasMultipleGoodsPerCaseValuesByName(item.goodName)) {
                return item;
            }

            // Si el producto existe (idGood relleno):
            if (item.idGood) {
                const good = this.GoodList.find(g => g.id === item.idGood);
                if (good && good.amountPerBox > 0) {
                    // Sólo autocompletar si goodsPerCase == 0
                    item.goodsPerCase = good.amountPerBox;
                }
            }

            // Si el producto NO existe (idGood vacío):
            // → NO tocar goodsPerCase bajo ningún concepto
            return item;
        }).sort((a, b) => a.goodName.localeCompare(b.goodName));
    }

    searchSuggestionGoods() {
        if (this.searchGoods !== '') {
            this.$emit('searchSugestionGoods', this.searchGoods);
        } else {
            this.showMessageWarning("Please enter at least 2 characters to search.");
        }
    }

    updateCasesPerPallet(item: IBORInboundDetailType) {
        // Validación simple de entrada
        if (item.casesPerPallet <= 0 || isNaN(item.casesPerPallet)) {
            this.showMessageWarning(`Please enter a valid value for cases per pallet for ${item.goodName}.`);
            return;
        }

        // Recalcular total de cajas si tiene palletsAmount
        if (item.palletsAmount > 0) {
            item.totalCases = item.casesPerPallet * item.palletsAmount;
        }

        // Revalida el detalle
        this.validateImportDetails();

        // Mostrar confirmación visual
        this.showMessageInfo(`Cases per pallet updated for ${item.goodName}.`);
    }

    openValidationDialog(item: IBORInboundDetailType) {
        this.selectedValidationItem = item;

        if (item.validations.length > 0) {
            try {
                this.validations = item.validations;
            } catch (error) {
                console.error("Error parsing validation data:", error);
                this.validations = [];
            }
        } else {
            this.validations = [];
        }

        this.dialogValidated = true;
    }

    hasValidationCode(item: IBORInboundDetailType, code: number): boolean {
        return item.validations && item.validations.some(validation => validation.ErrorCode === code);
    }

    GetValueDocumentation(documentationNeeded : boolean) {
        if (documentationNeeded !== null && documentationNeeded !== undefined) {
            if (documentationNeeded.toString() === 'true') {
                return 'Yes';
            } else {
                return 'No';
            }
        }

        return 'No';
    }
    getFiltered(items: IBORInboundDetailType[]) {
        this.selectedBORInboundDetailsSelectAll = items;
    }

    select(item: IBORInboundDetailType) {
        const idx = this.selectedBORInboundDetails.indexOf(item);
        if (idx < 0) {
            this.selectedBORInboundDetails.push(item);
        } else {
            this.selectedBORInboundDetails.splice(idx, 1);
            if (this.selectedBORInboundDetails.length === 0) {
                this.activeSelectAll = false;
            }
        }
    }

    get canShowImportButton(): boolean {
        return this.BORInboundDetails.every(item =>
            Array.isArray(item.validations) && item.validations.length === 0
        );
    }

    selectAll(active : boolean) {
        this.clearSelection();

        if (active) {
            const list = this.selectedBORInboundDetailsSelectAll;
            list.forEach(item => {
                if (!this.selectedBORInboundDetails.includes(item)) {
                    this.select(item);
                }
            });
        }
    }

    clearSelection() {
        this.selectedBORInboundDetails = [];
    }

    openEditorPalletType(item: IBORInboundDetailType) {
        let index = this.PalletTypeList.findIndex(p => p.id === item.idListPallet);
        this.selectedPalletType = this.PalletTypeList[index];
    }

    savePalletTypes() {
        let indexPallet = this.PalletTypeList.findIndex(p => p.name === this.selectedPalletTypeName);
        this.selectedBORInboundDetails.forEach(l => {
            l.idListPallet = this.PalletTypeList[indexPallet].id;
            l.palletName = this.PalletTypeList[indexPallet].name;
            let index = this.BORInboundDetails.findIndex(t => t.id === l.id);
            if (index !== -1) {
                this.BORInboundDetails[index].idListPallet = this.PalletTypeList[indexPallet].id;
                this.BORInboundDetails[index].palletName = this.PalletTypeList[indexPallet].name;
            }
        });
        this.validateImportDetails();
        this.showMessageInfo('Pallet types updated successfully for the selected items.');
        this.dialogPalletType = false;
    }

    savePalletTypeSingle(item: IBORInboundDetailType) {
        let indexPallet = this.PalletTypeList.findIndex(p => p.id === item.idListPallet);
        item.idListPallet = this.PalletTypeList[indexPallet].id;
        let index = this.BORInboundDetails.findIndex(t => t.id === item.id);
        if (index !== -1) {
            this.BORInboundDetails[index].idListPallet = this.PalletTypeList[indexPallet].id;
            this.BORInboundDetails[index].palletName = this.PalletTypeList[indexPallet].name;
        }
        this.validateImportDetails();
        this.showMessageInfo(`Pallet type updated successfully for item: ${item.goodName}`);
    }

    savePalletAmounts() {
        this.selectedBORInboundDetails.forEach(l => {
            l.palletsAmount = this.selectedPalletAmount;
            let index = this.BORInboundDetails.findIndex(t => t.id === l.id);
            if (index !== -1) {
                this.BORInboundDetails[index].palletsAmount = this.selectedPalletAmount;
            }
        });
        this.validateImportDetails();
        this.showMessageInfo(`Pallet amount updated successfully to ${this.selectedPalletAmount} for the selected items.`);
        this.dialogPalletAmount = false;
    }

    updateMultipleBestBeforeDates() {
        this.selectedBORInboundDetails.forEach(l => {
            l.bestBeforeDate = new Date(this.bestBeforeDate);
            let index = this.BORInboundDetails.findIndex(t => t.id === l.id);
            if (index !== -1) {
                this.BORInboundDetails[index].bestBeforeDate = new Date(this.bestBeforeDate);
            }
        });
        this.validateImportDetails();
        this.showMessageInfo(`Best Before Date updated successfully to ${this.bestBeforeDate} for the selected items.`);
        this.dialogBestBeforeDate = false;
    }

    saveLanguages() {
        if (!this.selectedLanguage) {
            this.showMessageWarning("Please enter a language.");
            return;
        }

        this.selectedBORInboundDetails.forEach((item) => {
            item.language = this.selectedLanguage;
            let index = this.BORInboundDetails.findIndex(t => t.id === item.id);
            if (index !== -1) {
                this.BORInboundDetails[index].language = this.selectedLanguage;
            }
        });
        this.validateImportDetails();
        this.showMessageInfo(`Language updated successfully to "${this.selectedLanguage}" for the selected items.`);
        this.dialogLanguage = false;
    }

    saveT1() {
        this.selectedBORInboundDetails.forEach((item) => {
            item.documentation = this.selectedT1;
            let index = this.BORInboundDetails.findIndex(t => t.id === item.id);
            if (index !== -1) {
                this.BORInboundDetails[index].documentation = this.selectedT1;
            }
        });
        this.validateImportDetails();
        this.showMessageInfo(`Douana document needed updated successfully to "${this.selectedT1 ? 'Yes' : 'No'}" for the selected items.`);
        this.dialogT1 = false;
    }

    async cloneBORInboundDetail(item: IBORInboundDetailType) {
        // Forzar que cualquier v-model pendiente en inputs se actualice
        if (document && document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        await this.saveImportDetails();
        await this.$emit('cloneBORInboundDetail', item);
    }

    deleteBORInboundDetail(item: IBORInboundDetailType) {
        this.$emit('deleteBORInboundDetail', item);
    }

    validateImportDetails() {
        this.$emit('validateBORInboundDetails', this.BORInboundDetails);
    }

    getGoodName(eanCode: string) {
        let index: number = this.GoodList.findIndex(g => g.eanCode === eanCode);
        if (index !== -1) {
            this.$emit('searchSugestionGoods', this.GoodList[index].name);
            return this.GoodList[index].name;
        }
        return '';
    }

    createModifyProduct(item?: IBORInboundDetailType) {
        if (!item) {
            // Crear lista de productos sin idGood
            const uniqueProducts = new Map<string, IBORInboundDetailType>();

            this.BORInboundDetails.forEach(p => {
                if (!p.idGood) {
                    // Usamos clave combinada: eanCode o, si está vacío, goodName
                    const key = p.eanCode && p.eanCode.trim() !== ""
                        ? p.eanCode.trim()
                        : p.goodName.trim().toLowerCase();

                    if (!uniqueProducts.has(key)) {
                        uniqueProducts.set(key, p);
                    }
                }
            });

            this.newProductsList = Array.from(uniqueProducts.values());

            if (this.newProductsList.length > 0) {
                this.dialogCreateModifyGood = true;
            } else {
                this.showMessageWarning("There are no new products to add.");
            }
            return;
        }

        // Si se pasa un item, solo se trabaja con ese producto
        this.copyBORInboundDetail = JSON.parse(JSON.stringify(item));
        this.newProductsList = [JSON.parse(JSON.stringify(item))];
        this.searchGoods = item.goodName || '';
        this.$emit('searchSugestionGoods', item.goodName);
        this.dialogCreateModifyGood = true;
    }

    async saveImportDetails() {
        await this.$emit('saveBORInboundDetails', this.BORInboundDetails);
    }

    deleteImport() {
        this.$emit('deleteImport');
        this.resetImport();
        this.dialog = true;
    }

    importFinal() {
        this.dialog = false;
        this.$emit('importFinal', this.BORInboundDetails);
        this.resetImport();
    }

    resetImport() {
        this.selectedBORInboundDetails = [];
        this.selectedBORInboundDetailsSelectAll = [];
        this.selectedPalletType = {} as IListPalletType;
        this.selectedPalletTypeName = "";
        this.selectedPalletAmount = 0;
        this.selectedValidationItem = {} as IBORInboundDetailType;
        this.selectedBestBeforeDate = new Date();
        this.selectedT1 = false;
        this.selectedLanguage = "";
        this.dialog = false;
        this.dialogPalletType = false;
        this.dialogPalletAmount = false;
        this.dialogValidated = false;
        this.dialogBestBeforeDate = false;
        this.dialogCreateModifyGood = false;
        this.dialogT1 = false;
        this.dialogLanguage = false;
        this.bestBeforeDate = new Date().toISOString().substr(0, 10);
        this.menuBestBeforeDate = false;
        this.validations = [];
        this.searchGoods = "";
        this.goodToAdd = {} as BORGoodSave;
        this.copyBORInboundDetail = {} as IBORInboundDetailType;
        this.newProductsList = [];
    }

    closeValidated() {
        this.dialogValidated = false;
        this.validations = [];
    }
    
    createNewProduct(item: IBORInboundDetailType) {
        this.goodToAdd.id = '';
        this.goodToAdd.name = item.goodName;
        this.goodToAdd.code = '';
        this.goodToAdd.eanCode = item.eanCode;
        this.goodToAdd.sku = item.sku;
        this.goodToAdd.specifications = '';
        this.goodToAdd.amount = item.goodsPerCase === 0 ? "1" : item.goodsPerCase.toString();
        this.$emit('createNewProducts', [this.goodToAdd]);
        this.newProductsList = this.newProductsList.filter(prod => prod.id !== item.id);
        if (this.newProductsList.length === 0) {
            this.dialogCreateModifyGood = false;
        }
    }

    createAllNewProducts() {
        if (this.newProductsList.length > 0) {
            let goodsToAdd: BORGoodSave[] = [];

            this.newProductsList.forEach((item) => {
                let goodToAdd: BORGoodSave = {
                    id: '',
                    name: item.goodName,
                    code: '',
                    eanCode: item.eanCode,
                    sku: '',
                    specifications: '',
                    amount: item.goodsPerCase === 0 ? "1" : item.goodsPerCase.toString(),
                    user: ''
                };
                goodsToAdd.push(goodToAdd);
            });

            if (goodsToAdd.length > 0) {
                this.$emit('createNewProducts', goodsToAdd);
                this.dialogCreateModifyGood = false;
                this.showMessageInfo(`${goodsToAdd.length} products added successfully.`);
            } else {
                this.showMessageWarning("No products available to add.");
            }
        } else {
            this.showMessageWarning("No products available to add.");
        }
    }

    updateBORInboundDetailGood() {
        let index : number = this.BORInboundDetails.findIndex(c => c.id === this.copyBORInboundDetail.id);
        this.BORInboundDetails[index].goodName = this.newProductsList[0].goodName;
        this.BORInboundDetails[index].eanCode = this.newProductsList[0].eanCode;
        this.BORInboundDetails[index].idGood = this.newProductsList[0].idGood;
        this.BORInboundDetails[index].goodsPerCase = this.newProductsList[0].goodsPerCase;
        this.validateImportDetails();
        this.dialogCreateModifyGood = false;
    }

    async updateExistingProduct(item: IBORInboundDetailType) {
        try {
            await new Promise<void>((resolve, reject) => {
                this.$emit("updateExistingProduct", item, resolve, reject);
            });

            this.validateImportDetails();
            this.showMessageInfo("The product has been successfully updated and validated.");
        } catch (error) {
            this.showMessageError("Failed to update product.");
        } finally {
            this.dialogCreateModifyGood = false;
        }
    }

    useExistingGood() {
        let index: number = this.BORInboundDetails.findIndex(g => g.id === this.selectedBORInboundDetails[0].id);
        if (index !== -1) {
            let indexGood: number = this.GoodList.findIndex(good => good.eanCode === this.selectedBORInboundDetails[0].eanCode);
            if (indexGood !== -1) {
                this.BORInboundDetails[index].goodName = this.GoodList[indexGood].name;
                this.BORInboundDetails[index].eanCode = this.GoodList[indexGood].eanCode;
                this.BORInboundDetails[index].idGood = this.GoodList[indexGood].id;
                this.BORInboundDetails[index].goodsPerCase = this.GoodList[indexGood].amountPerBox;
                this.validateImportDetails();
                this.dialogCreateModifyGood = false;
            }
        }
    }

    cancelBORInboundDetailGood() {
        if (this.copyBORInboundDetail && Object.keys(this.copyBORInboundDetail).length > 0) {
            let index : number = this.BORInboundDetails.findIndex(c => c.id === this.copyBORInboundDetail.id);
            this.BORInboundDetails[index].goodName = this.copyBORInboundDetail.goodName;
            this.BORInboundDetails[index].eanCode = this.copyBORInboundDetail.eanCode;
            this.BORInboundDetails[index].sku = this.copyBORInboundDetail.sku;
            this.BORInboundDetails[index].idGood = this.copyBORInboundDetail.idGood;
            this.BORInboundDetails[index].goodsPerCase = this.copyBORInboundDetail.goodsPerCase;
            this.copyBORInboundDetail = {} as IBORInboundDetailType;
        }
        this.dialogCreateModifyGood = false;
    }

    changeProductInboundDetail(item: BORGood) {
        if (this.newProductsList.length === 1) {
            this.copyBORInboundDetail = JSON.parse(JSON.stringify(this.newProductsList[0]));
            this.newProductsList[0].goodName = item.name;
            this.newProductsList[0].eanCode = item.eanCode;
            this.newProductsList[0].sku = item.sku;
            this.newProductsList[0].idGood = item.id;
            this.newProductsList[0].goodsPerCase = item.goodsPerCase;
        }
    }

    cancel () {
    }

    close () {
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
